
export default {
  code: "gl",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Ant",
    next: "Seg",
    today: "Hoxe",
    month: "Mes",
    week: "Semana",
    day: "Día",
    list: "Axenda"
  },
  weekLabel: "Sm",
  allDayHtml: "Todo<br/>o día",
  eventLimitText: "máis",
  noEventsMessage: "Non hai eventos para amosar"
};
